import React, {FC, MouseEvent, useState, useEffect, ChangeEvent}  from 'react';
import {useParams} from 'react-router';
import { useNavigate } from 'react-router-dom';

import { useTranslation  } from 'react-i18next';


// import MUI.
import {Avatar, Button, Grid, Typography, Link, Box, Paper, TextField, 
  MenuItem, IconButton, Checkbox, FormControlLabel } from '@mui/material';
import {Menu as MenuIcon, AccountCircle as AccountCircleIcon, 
  Home as HomeIcon, ManageAccounts as ManageAccountsIcon, Logout as LogoutIcon, Search as SearchIcon } from '@mui/icons-material';
import AddCircleIcon from '@mui/icons-material/AddCircle';

import InputAdornment from '@mui/material/InputAdornment';

import { DatePicker } from '@mui/x-date-pickers';


// import library.
import { useFieldArray, useForm, useFormContext, Controller, FormProvider, FieldArrayWithId, ArrayPath } from 'react-hook-form';
import {useQuery,useQueryClient, QueryClient, QueryClientProvider, useMutation, useQueries, UseQueryResult } from "react-query";
import { useSnackbar } from 'notistack';


import IBankPerson, {defaultBankPerson} from './model/BankPerson';
import IBankPolicy from './model/BankPolicy';

import useBankPersonService from './service/BankPerson';
import {IEnumerationItem} from '../configuration/model/Enumeration';

import {useUserStore} from '../../library/store'; 
import useEnumerationService from '../configuration/service/Enumeration';

const BankPersonForm: FC<IBankPerson> = (props: IBankPerson = defaultBankPerson) => {

    const { setCurrentEntity, currentUser} = useUserStore();
    const {language: lg} = currentUser;

    const navigate = useNavigate();

    const { t, i18n } = useTranslation();

    const {bankPersonID} = useParams();

    const { enqueueSnackbar } = useSnackbar();

    const [_bankPersonID, _setBankPersonID] = useState<number>( Number( bankPersonID || 0 ) );

    // const methods = useForm()

    // const methods = useForm    <IBankPerson>( {defaultValues:defaultBankPerson} );
    const methods = useFormContext<IBankPolicy>();

    const { register, setValue ,getValues, watch, reset ,handleSubmit ,control , formState: { errors } } = methods;

    const {getEnumerationItemsList, getEnumerationItemsLanguageList} = useEnumerationService();

    // const {isSuccess: isCivilitiesSuccess, status: civilitiesStatus,data: allCivilities} = useQuery<IEnumerationItem[]>("civilities", () => getEnumerationItemsList('CIVILITE'));
    // const {isSuccess: isCatProfsSuccess, status: catProfsStatus,data: allCatProfs} = useQuery<IEnumerationItem[]>("catProfs", () => getEnumerationItemsList('PROFESSION'));
    // const {isSuccess: isSitMatSuccess, status: sitMatStatus,data: allSitMat} = useQuery<IEnumerationItem[]>("sitMats", () => getEnumerationItemsList('SIT_MATRIM'));
    // const {isSuccess: isLanguagesSuccess, status: languagesStatus,data: allLanguages} = useQuery<{cultureName:string, cultureDescription:string}[]>("languages", getLanguagesList);

    const [ 
      {isSuccess: isCivilitiesSuccess, status: civilitiesStatus,data: allCivilities},
      {isSuccess: isCatProfsSuccess, status: catProfsStatus,data: allCatProfs},
      {isSuccess: isSitMatSuccess, status: sitMatStatus,data: allSitMat},
      {isSuccess: isLanguagesSuccess, status: languagesStatus,data: allLanguages},

    ] = useQueries([  
  {queryKey: ['civilities'], queryFn: () => getEnumerationItemsList('CIVILITE')},
  {queryKey: ['catProfs'], queryFn: () => getEnumerationItemsList('PROFESSION')},
  {queryKey: ['sitMats'], queryFn: () => getEnumerationItemsList('SIT_MATRIM')},
  {queryKey: ['languages'], queryFn: () => getEnumerationItemsLanguageList()},
]) as UseQueryResult<IEnumerationItem[]>[];


    // const  {saveBankPerson, getBankPerson} = useBankPersonService();

    // const queryClient = useQueryClient();
    // const {isLoading, isError, isSuccess ,error,mutate } = useMutation<IBankPerson,Error,IBankPerson>(saveBankPerson, 
    //   {        
    //     onSuccess: (data: IBankPerson) => {
    //       enqueueSnackbar( '_Operation_done', { variant: 'success',
    //             anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 1000 }); 
          
    //       reset(data);
    //       queryClient.invalidateQueries(['BankPerson',data.bankPersonID]);
    //     },
    //     onError: (err: Error) => {
          
    //       enqueueSnackbar( error, { variant: 'error',
    //             anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
    //     }
    //   });

    // const {data: _data} = useQuery<IBankPerson>(['BankPerson', _bankPersonID], () => getBankPerson( _bankPersonID  ), 
    // {enabled: _bankPersonID > 0 } );

    // useEffect( () => {setCurrentEntity('BankPerson');}, [] );

    // useEffect( () => { 
    //   const data = getValues();
    //   const tmpBankPersonID = data.bankPersonID || 0;
    //   if(_bankPersonID !== tmpBankPersonID) {    //console.log('useEffect ...'); console.log(_data);  
    //     reset(_data);
    //   }

    // }, [_data, reset]);

    


      // const saveData = async (event: MouseEvent<HTMLButtonElement>) => {
        
      //   const data = getValues();        
      //   mutate(data);
      // }

      // const listData = async (event: MouseEvent<HTMLButtonElement>) => {
      //   navigate('/bankPersonList');
      //   //setOpenRoleList(true);
      // }


    return (
      <>
        {/* <FormProvider {...methods} > */}
            <Grid container component="main" sx={{  width: '100%' }} alignItems="flex-start">
              <Grid item xs={12} sm={6} md={6} component={Paper} elevation={2} square>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                  <Box sx={{ mt: 1, width: '100%' }} >                                       
                    <TextField sx={{width:'calc(50% - 8px)'}} id="bankPersonID" label="ID"
                     inputProps={ {readOnly: true}} />  
                    
                    <Controller name='defaultLanguage' control={control} defaultValue=''
                        render={ ({field: {onChange, value}}) => (
                          <TextField select onChange={onChange} value={value} sx={{width:'calc(50% - 8px)'}} id="defaultLanguage" label={t('Language')}>
                          {allLanguages && allLanguages.map( 
                            (lg,idx) => <MenuItem key={lg.enumerationItemCode} value={lg.enumerationItemCode}>{lg.enumerationItemName}</MenuItem> )
                          }
                          </TextField>
                        )}
                      />                
                  </Box>  
                  <Box sx={{ mt: 1, width: '100%' }} >
                    <Controller name='civility' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(50% - 8px)'}} id="civility" label={t('Civility')}>
                        {allCivilities && allCivilities.map( 
                        (cv,idx) => <MenuItem key={cv.enumerationItemCode} value={cv.enumerationItemCode}>{cv.enumerationItemName}</MenuItem> )
                      }
                        </TextField>
                      )}
                    />
                    <Controller name='maritalSituation' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(50% - 8px)'}} id="maritalSituation" label={t('Mat. Sit.')}>
                        {allSitMat && allSitMat.map( 
                          (sm,idx) => <MenuItem key={sm.enumerationItemCode} value={sm.enumerationItemCode}>{sm.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                    />                      
                    
                  </Box>
                  <Box sx={{ mt: 1, width: '100%' }} >  
                    <TextField  sx={{width:'calc(50% - 8px)'}} id={lg.startsWith('fr')?'lastName':'firstName'} label={t(lg.startsWith('fr')?'Last Name':'First Name')} {...register(lg.startsWith('fr')?'lastName':'firstName')} />                                  
                    <TextField  sx={{width:'calc(50% - 8px)'}} id={lg.startsWith('fr')?'firstName':'lastName'} label={t(lg.startsWith('fr')?'First Name':'Last Name')} {...register(lg.startsWith('fr')?'firstName':'lastName')} />       
                  </Box>
                  <Box sx={{ mt: 1, width: '100%' }} >
                    <TextField  sx={{width:'calc(100% - 8px)'}} id="personNameNIC" label="Person Name NIC" {...register('personNameNIC')}/>
                  </Box>
                  <Box sx={{ mt: 1, width: '100%' }} >  
                    <Controller control={control}
                        name='birthDate' 
                        render={({ field: { onChange, onBlur, value, ref } }) => (
                          <DatePicker label={t('Birth Date')}
                            onChange={onChange}                        
                            value={value}
                            renderInput={(params) => <TextField {...params} sx={{width:'calc(30% - 8px)'}} />}
                          /> )}
                    />                                     
                    <TextField  sx={{width:'calc(70% - 8px)'}} id="birthPlace" label={t('BirthPlace')} {...register('birthPlace')}  />     
                  </Box>

                  
                  <Box sx={{ mt: 1, width: '100%' }} >
                    <TextField  sx={{width:'calc(100% - 8px)'}} id="personIndice" label="Indice" {...register('personIndice')}/>     
                  </Box>
                  <Box sx={{ mt: 1, width: '100%' }} >  
                    <TextField  sx={{width:'calc(50% - 8px)'}} id="firstName" label={t('Height')} {...register('height')} />                                  
                    <TextField  sx={{width:'calc(50% - 8px)'}} id="lastName" label={t('Weight')}  {...register('weight')} />       
                  </Box>
                </Box>  
              </Grid>
              <Grid item xs={12} sm={6} md={6} component={Paper} elevation={6} square>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }} >
                  <Box sx={{ mt: 1, width: '100%' }} >  
                    <TextField  sx={{width:'calc(30% - 8px)'}} id="portable1" label={t('Portable1')} {...register('portable1')} />                                  
                    <TextField  sx={{width:'calc(70% - 8px)'}} id="email1" label={t('Email1')} {...register('email1')}
                      inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } } />       
                  </Box>
                  <Box sx={{ mt: 1, width: '100%' }} >  
                    <TextField  sx={{width:'calc(30% - 8px)'}} id="portable2" label={t('Portable2')} {...register('portable2')} />                                  
                    <TextField  sx={{width:'calc(70% - 8px)'}} id="email2" label={t('Email1')} {...register('email2')} 
                      inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } } />       
                  </Box>
                  <Box sx={{ mt: 1, width: '100%' }} >
                    <TextField  sx={{width:'calc(100% - 8px)'}} id="adressLine1" label={t('AdressLine1')} {...register('adressLine1')}/>     
                  </Box>
                  <Box sx={{ mt: 1, width: '100%' }} >
                    <TextField  sx={{width:'calc(100% - 8px)'}} id="adressLine2" label={t('AdressLine2')} {...register('adressLine2')}/>     
                  </Box>
                  <Box sx={{ mt: 1, width: '100%' }} >  
                    <Controller name='professionalCategory' control={control} defaultValue=''
                      render={ ({field: {onChange, value}}) => (
                        <TextField select onChange={onChange} value={value} sx={{width:'calc(40% - 8px)'}} id="professionalCategory" label={t('ProfessionalCategory')} >
                        {allCatProfs && allCatProfs.map( 
                          (cp,idx) => <MenuItem key={cp.enumerationItemCode} value={cp.enumerationItemCode}>{cp.enumerationItemName}</MenuItem> )
                        }
                        </TextField>
                      )}
                    />                    
                    <TextField  sx={{width:'calc(60% - 8px)'}} id="profession" label={t('Profession')} {...register('profession')} />       
                  </Box>
                </Box>
              </Grid>            
          </Grid>
        {/* </FormProvider> */}
      </>
    );
}

export default BankPersonForm;